import { Image } from '~/lib/ApiModel';
import React from 'react';
import './OSSelector.scss';
import { SelectButtonList, SelectButtonItem } from '~/components/SelectButtonList';
import {
    versionForOperatingSystem,
    distributionsFromOperatingSystems,
    operatingSystemsForDistribution,
    logoForDistribution,
} from '~/lib/helper/OperatingSystemHelper';

type OSSelectorProps = {
    operatingSystems: Image[];
    selected?: string;
    onOperatingSystemSelected?: (selected: Image | undefined) => unknown;
};

export default class OSSelector extends React.Component<OSSelectorProps> {
    get selectedDistribution(): string | undefined {
        return this.props.operatingSystems.find((os) => os.slug === this.props.selected)?.distribution ?? undefined;
    }

    selectDistribution(distribution: string) {
        const validOses = operatingSystemsForDistribution(distribution, this.props.operatingSystems);
        if (!validOses.find((o) => o.slug === this.props.selected)) {
            this.props.onOperatingSystemSelected?.(validOses[0]);
        }
    }

    distributionButton(distribution: string) {
        const isSelected = distribution === this.selectedDistribution;
        return (
            <SelectButtonItem
                key={distribution}
                isSelected={isSelected}
                onSelect={() => this.selectDistribution(distribution)}
            >
                <img src={logoForDistribution(distribution)} alt="" />
                {distribution}
            </SelectButtonItem>
        );
    }

    distributionList() {
        const distributions = distributionsFromOperatingSystems(this.props.operatingSystems);
        return (
            <SelectButtonList legend="Operating system">
                {distributions.map((d) => this.distributionButton(d))}
            </SelectButtonList>
        );
    }

    versionList() {
        if (!this.selectedDistribution) return null;

        const versions = operatingSystemsForDistribution(this.selectedDistribution, this.props.operatingSystems);

        return (
            <div>
                <h5>Select Version</h5>
                <SelectButtonList legend="Version">
                    {versions.map((d) => this.operatingSystemButton(d, versionForOperatingSystem(d)))}
                </SelectButtonList>
            </div>
        );
    }

    operatingSystemButton(os: Image, caption: string) {
        const { selected, onOperatingSystemSelected } = this.props;
        const isSelected = os.slug === selected;
        return (
            <SelectButtonItem key={os.id} isSelected={isSelected} onSelect={() => onOperatingSystemSelected?.(os)}>
                {caption}
            </SelectButtonItem>
        );
    }

    render() {
        return (
            <div className="OSSelector">
                {this.distributionList()}
                {this.versionList()}
            </div>
        );
    }
}
